import { render, staticRenderFns } from "./Apparatus.vue?vue&type=template&id=10d312ff&scoped=true"
import script from "./Apparatus.vue?vue&type=script&lang=js"
export * from "./Apparatus.vue?vue&type=script&lang=js"
import style0 from "./Apparatus.vue?vue&type=style&index=0&id=10d312ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d312ff",
  null
  
)

export default component.exports